import { useData } from '@/i18n/LangContext';

interface CvInterestsProps {
  interests?: string[];
}

export default function CvInterests({ interests }: CvInterestsProps) {
  const data = useData();
  const items = interests ?? data.cv.interests;
  return (
    <div className="flex flex-wrap gap-3 print:gap-1.5">
      {items.map((interest, index) => (
        <div 
          key={index} 
          className="px-4 py-2 rounded-lg bg-[rgba(198,156,109,0.1)] border border-[rgba(198,156,109,0.2)] print:bg-white print:border-gray-300 print:py-1 print:px-3"
        >
          <span className="print:text-black">{interest}</span>
        </div>
      ))}
    </div>
  );
} 